import type { SearchParameters } from 'ofetch'
import type { AvailableRouterMethod, NitroFetchOptions, NitroFetchRequest } from 'nitropack'
import {
  handleError,
  handleRequest,
  handleRequestError,
  handleResponse,
  type ResOptions
} from '~/composables/httpHelper'

const fetch = async <R extends NitroFetchRequest, M extends AvailableRouterMethod<R>, T = any>(
  url: string,
  opts: NitroFetchOptions<R, M>
) => {
  const meta: Record<string, any> = {}
  const { public: env } = useRuntimeConfig()
  //baseUrl 为空时 使用NUXT 代理
  const baseUrl = import.meta.client && !url.includes('ossApi') ? env.config.API_BASE_URL : ''

  const token = useCookie<string | undefined>('access_token')
  const { $i18n } = useNuxtApp()

  const locale = $i18n.locale.value as keyof typeof ELocale

  return $fetch<ResOptions<T>>(url, {
    baseURL: baseUrl,
    retry: 3, // 重试次数
    retryDelay: 500,
    // 请求拦截
    onRequest(ctx) {
      handleRequest(meta, token, locale, ctx, opts)
    },
    // 请求错误拦截
    onRequestError(ctx) {
      handleRequestError(ctx, token)
    },
    // 响应拦截
    onResponse(ctx) {
      handleResponse(meta, token, ctx)
    },
    // 错误拦截
    onResponseError(ctx) {
      handleError(ctx, token)
    },
    // 合并 options
    ...opts
  })
}

export const useHttp = {
  get: <R extends NitroFetchRequest, M extends AvailableRouterMethod<R>>(
    url: string,
    params?: SearchParameters,
    option?: NitroFetchOptions<R, M>
  ) => {
    return fetch(url, { method: 'GET', params, ...option }) // .then(res => res.data.value);
  },

  post: <R extends NitroFetchRequest, M extends AvailableRouterMethod<R>>(
    url: string,
    body?: RequestInit['body'] | Record<string, any>,
    option?: NitroFetchOptions<R, M>
  ) => {
    //   console.log('40-40', {...option})
    return fetch(url, { method: 'POST', body, ...option }) // .then(res => res.data.value);
  },

  put: <R extends NitroFetchRequest, M extends AvailableRouterMethod<R>>(
    url: string,
    body?: RequestInit['body'] | Record<string, any>,
    option?: NitroFetchOptions<R, M>
  ) => {
    return fetch(url, { method: 'PUT', body, ...option }) // .then(res => res.data.value);
  },

  delete: <R extends NitroFetchRequest, M extends AvailableRouterMethod<R>>(
    url: string,
    body?: RequestInit['body'] | Record<string, any>,
    option?: NitroFetchOptions<R, M>
  ) => {
    return fetch(url, { method: 'DELETE', body, ...option }) // .then(res => res.data.value);
  }
}
